import React from "react";
import Select from "react-select";

export default class SelectCourse extends React.Component {
	state = {
		selectedOption: null,
	};

	handleChange = (selectedOption) => {
		this.setState({ selectedOption });
		this.props.onSelectCourse(selectedOption.value);
	};

	render() {
		const { selectedOption } = this.state;
		const options = this.props.listCourse
			? this.props.listCourse.filter(Boolean)
			: [];

		return (
			<Select
				value={selectedOption}
				onChange={this.handleChange}
				options={options}
				placeholder="Pilih Mata Pelajaran"
				isLoading={!this.props.listCourse}
				noOptionsMessage={() => "Tidak ada data"}
				isSearchable={true}
			/>
		);
	}
}
